const action = name => `ADV.FINANCIAL_PLAN.${name}`;

export const CLEAR_GOALS_SUMMARY = action('CLEAR_GOALS_SUMMARY');

export const clearGoalsSummary = () => ({
  type: CLEAR_GOALS_SUMMARY,
});
